import { useState, useEffect } from 'react';
import { User } from 'firebase/auth';
import { subscribeToAuthState } from '../services/authService';
import { createUserDocument, getUserDocument, updateLastLogin } from '../services/userService';
import { AppUser } from '../types';

export interface AuthState {
  firebaseUser: User | null;
  appUser: AppUser | null;
  loading: boolean;
}

export function useAuth(): AuthState {
  const [firebaseUser, setFirebaseUser] = useState<User | null>(null);
  const [appUser, setAppUser] = useState<AppUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = subscribeToAuthState(async (user) => {
      setFirebaseUser(user);
      if (user) {
        const nameParts = (user.displayName ?? '').split(' ');
        const firstname = nameParts[0] ?? '';
        const lastname = nameParts.slice(1).join(' ');
        try {
          await createUserDocument(user.uid, user.email ?? '', firstname, lastname);
        } catch (error) {
          console.warn('Could not create user document:', error);
        }
        const profile = await getUserDocument(user.uid);
        setAppUser(profile);
        updateLastLogin(user.uid).catch(error => {
          console.warn('Could not update last login timestamp:', error);
        });
      } else {
        setAppUser(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return { firebaseUser, appUser, loading };
}
